module.exports = __webpack_public_path__ + "img/intro2_ja.95f8504a.jpg";